const urls = {
    login: '/api/v1/auth/login/', // User login
    signUp: '/api/v1/auth/register', // signup user
    getUserInfo: '/api/v1/user/detail', // Get user info ["required permission here"]
    getUserList:'/api/v1/user/list',
    getUserById:'/api/v1/user/info/:id',
    putUserById:'/api/v1/user',
    userCategory:'/api/v1/user-category',
    fileUpload: '/api/v1/file', // Upload file []

    getTeam:'/api/v1/team' ,  //Get all team member

    getActivity:'/api/v1/event',
    getResource:'api/resources/',
    getGallery:'api/getGallery/',
    addContact:'/api/contactus/',
    addStudent:'/api/students',
    getQuiz:'/api/v1/quiz/',
    addCategory:'/api/v1/category',
    getCategories: '/api/v/', // Get all job categories []
    addActivity:'/api/v1/event',
    addQuiz:'/api/v1/quiz',
    getQuestion:'/api/v1/question',
    addQuestionAnswer:'/api/v1/question/answer',
    questionCategory:'api/v1/category',
    getEvent:'/api/v1/event',
    eventDetail:'/api/v1/event/:id',
    registerEvent:'/api/v1/event/registers',
    activityScore:'/api/v1/event/judge/score',
    activityScoreByParticipant:'/api/v1/event/judge/score/:eid/:pid',

    getQuizResult:'/api/v1/event/quiz/score/:id',
    discussion: {
      createDiscussion: '/api/v1/discussion/',
      getAll: '/api/v1/discussion',
      getDiscussionTree:'/api/v1/discussion/tree',
      getDetail:'/api/v1/discussion/:id',
      likeDiscussion: '/api/v1/discussion/like/:id',
    },
    gallery:{
      createGallery:'/api/v1/gallary',
      getGallery:'/api/v1/gallary',
      getGallaryById:'/api/v1/gallary/:id'
    
    },
    download:{
      createDownload:'/api/v1/download',
      getDonwload:'/api/v1/download',
      getDownloadById:'/api/v1/download/:id'
    
    },
    contact:{
      createContact:'/api/v1/contact',
      getContact:'/api/v1/contact',
      getContactById:'/api/v1/contact/:id'
    },
    page:{
      getPage:'/api/v1/page/info',
      getPageById:'/api/v1/page/:id'
    }


  }
  
  export default urls
  